<template>
  <div class="container">
    <HeaderComponent class="no-print"></HeaderComponent>
    <main>
      <div class="wpb_wrapper">
        <div class="wpb_text_column wpb_content_element imprensa-assessoria">
          <div class="title">
            <h2>{{ translate.title }}</h2>
          </div>
        </div>
        <div class="row">
          <p><span v-html="getResult"></span></p>
        </div>
        <div class="row">
          <div class="col text-left count-result" v-if="reseller">
            <p class="d-inline"><span class="number">1 - </span> {{ translate.result }}</p>
          </div>
        </div>
        <div class="reseller" v-if="reseller">
          <div class="row wpsl-store-location">
            <div class="col text-left">
              <h2 class="title_reseller">{{ reseller.name }}</h2>
            </div>
          </div>
          <div class="row align-items-end">
            <div class="col result_reseller">
              <div v-if="reseller.address.address">
                  ENDEREÇO: {{ reseller.address.address }}
              </div>
              <div>
                CIDADE: {{ reseller.address.city }}
              </div>
              <div v-if="reseller.address.zipcode">
                  CEP: {{ reseller.address.zipcode }}
              </div>
              <div v-if="reseller.distance">
                DISTÂNCIA: {{ (reseller.distance) ? parseInt(reseller.distance) + 'km' : '' }}
              </div>
              <div v-if="reseller.phone">
                  TELEFONE: {{ reseller.phone }}
              </div>
              <div v-if="reseller.cellphone">
                  CELULAR: {{ reseller.cellphone }}
              </div>
              <div v-if="reseller.site">
                  SITE: {{ reseller.site }}
              </div>
              <div v-if="reseller.email">
                  E-EMAIL: {{ reseller.email }}
              </div>
              <div v-if="reseller.social_medias.facebook">
                  FACEBOOK: {{ reseller.social_medias.facebook }}
              </div>
              <div v-if="reseller.social_medias.instagram">
                INSTAGRAM: {{ reseller.social_medias.instagram }}
              </div>
            </div>
          </div>
          <div class="buttons custom-btn no-print" v-if="reseller">
            <button type="button" @click="print()" class="btn-impressao btn">
              <span>{{ translate.print }}</span>
            </button>
            <button type="button" @click="send()" class="btn-email btn" :disabled="sent">
              <span>{{ translate.send }}</span>
            </button>
              <div :class="['form-group', (sent) ? 'valid' : 'invalid', (message !== null) ? 'show': '']" >
                <div class="feedback message">{{ message }}</div>
              </div>
          </div>
          <div class="row">
            <div class="col">
              <google-map :lat="reseller.lat" :lng="reseller.lng"/>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="row">
            <div class="col-2 text-left buttons no-print">
              <router-link class="btn back" :to="{ name:'form', params: { language }}"><img width="15px" src="../assets/arrow.png" />{{ translate.button }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </main>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from './Header.vue';
import FooterComponent from './Footer.vue';
import { mapActions } from 'vuex'
import Events from '../shared/events';
import { resultEn, resultIt, resultEs, resultPt } from '../lang';
import GoogleMap from '../shared/GoogleMap';
import LeadService from "../service/lead";
import { lead } from './mockup';

export default {
  name: 'page-result',
  components: {
    HeaderComponent,
    FooterComponent,
    GoogleMap,
  },
  computed: {
    lead() {
      if (this.$store.state.lead) {
        return this.$store.state.lead;
      }
      return { ...lead };
    },
    reseller() {
      if (this.$store.state.reseller) {
        return this.$store.state.reseller;
      }
      return false;
    },
    getResult() {
      if (this.reseller) {
        return this.translate.thanks.replace('{zipcode}', this.zipcode);
      }
      return this.translate.no_results;
    },
  },
  data() {
    return {
      sent: false,
      language: this.$route.params.language,
      translate: { ...resultPt },
      message: null,
      zipcode: '',
    };
  },
  methods: {
    ...mapActions([
      'setLead',
    ]),
    checkLanguage() {
      this.language = this.$route.params.language;
      if (this.language) {
        switch (this.language) {
          case 'en':
            return this.setLanguage(resultEn);
          case 'es':
            return this.setLanguage(resultEs);
          case 'it':
            return this.setLanguage(resultIt);
          case 'pt':
          default:
            return this.setLanguage(resultPt);
        }
      }
    },
    closeMessage() {
      setTimeout(() => {
        if(this.sent) {
          this.message = 'Email enviado com sucesso!';
        } else {
          this.message = 'Erro ao enviar email!';
        }
      }, 2500);
    },
    print() {
      window.print();
    },
    setLanguage(language) {
      this.translate = language;
    },
    send() {
      LeadService.send(this.lead.id)
        .then(response => {
          this.sent = response.sent;
          this.closeMessage();
        });
    },
  },
  mounted() {
    this.checkLanguage();
    Events.$on('success', () => {
      this.zipcode = (this.lead) ? this.lead.zipcode : '';
    });
    Events.$on('change_translate', () => {
      this.checkLanguage();
    });
  },
}
</script>

<style lang="scss" scoped>

@media print {
  * { box-sizing: border-box; }
  .container {
    width: 1002px;
    margin: 6rem auto auto;
  }
  .no-print, .no-print * {
    display: none !important;
  }
}
.container {
  background-color:#333;
  main {
    .wpb_wrapper {
      width: 60rem;
      position: relative;
      .title {
        position: relative;
        h2 {
          font-weight: 500;
          font-family: "Oswald", sans-serif;
          font-size: 30px;
          text-transform: uppercase;
          letter-spacing: 4.8px;
          margin-bottom: 0.8rem;
        }
        p {
          margin: 50px 0;
          font-size: 16px;
        }
      }
    }
  }
}
.reseller {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px dotted #ccc;
  width: 100%;
}
.result_reseller {
  text-align: left;
  div {
    line-height: 35px;
    overflow-wrap: break-word;
    line-height: 22px;
    margin: 1.4rem 0;
  }
}
.row.align-items-end {
  display: flex;
  align-items: flex-end;
}
.d-inline {
  display: inline-block;
}

.custom-btn {
  margin: 1.5rem 0 1rem;
  width: 100%;
  .btn {
    padding: 0.8rem 3rem;
    margin-right: 0.8rem;
  }
}
.buttons {
  display: flex;
  text-align: center;
  .btn {
    cursor: pointer;
    background: #C52B2B;
    letter-spacing: 2px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    text-decoration: none;
    border: 0;
    text-align: center;
    position: relative;
    img {
      position: absolute;
      top: 50%;
      left: 30px;
      transform:  translateY(-50%);
    }
  }
}
.text-left {
  text-align: left;
}
.title_reseller {
  text-transform: uppercase;
  font-size: 18px;
  a {
    color: #000;
    text-decoration: none;
  }
}
.count-result {
  display: flex;
  align-items: center;
  font-weight: 700;
  .number {
    font-size: 16px;
  }
}
.btn {
  span {
    text-wrap: nowrap;
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 2px;
    text-align: center;
  }
  &:hover {
    border-color: #707070;
    background-position: -100% 0;
    background-color: #3C3C3C;
    transition: all .3s;
  }
}
.line {
  width: 45px;
  height: 5px;
  background: #000;
}
.row {
  display: flex;
  align-items: flex-start;
}
.row span {
  line-height: 1.5;
}
.col {
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
  &-1 {
    width: 245px;
    max-width: 245px;
  }
}
.title {
  width: 100%;
  text-align: left;
}
.footer {
  margin-top: 30px;
  width: 100%;
}
.back {
  color: #fff;
  background-color: #000;
  text-decoration: none;
  display: inline-block;
  padding-left: 2rem;
  width: 100%;
}

.position-fixed {
  position: fixed;
  bottom: 20px;
  width: 50%;
  margin: auto;
  left: 25%;
}
.form-group {
    width: 100%;
    max-width: 100%;
    text-align: left;
    .feedback {
        display: none;
        border: 2px solid #47e947 !important;
    }
    &.show {
        .feedback {
            display: block;
        }
    }
    &.invalid {
        .feedback {
            border: 2px solid red!important;
        }
    }
    .message {
        text-transform: uppercase;
        color: #fff;
        text-align: center;
        padding: 10px!important;
        font-size: 14px;
        letter-spacing: 2px;
    }
}

@media screen and (max-width: 1300px) {
  .container main :deep(.wpb_wrapper) {
    max-width: 100%!important;
  }
}

@media screen and (max-width: 970px) {
  .container main .wpb_wrapper {
    .row {
      .buttons {
        width: 100%;
        margin-top: 20px;
        padding-right: 0;
        .btn {
          flex: 0 1 180px;
        }
      }
      &.align-items-end {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .col {
          width: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 809px) {
  .result_reseller {
    div {
      font-size: 15px;
    }
  }
  .custom-btn {
    
    display: flex;
    flex-wrap: wrap;
    .btn {
      padding: 0.8rem 0.6rem;
      flex-grow: 1;
    }
    .btn-email {
      margin-right: 0;
    }
    .message {
      margin-top: 10px;
    }
  }
}

@media screen and (max-width: 336px) {
  .custom-btn {
    .btn {
      margin: 10px 0 0 0;
    }
  }
}

</style>